<template>
  <article>
    <div>
      <span class="xbed-sub-title">业主</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">蓝主人</BreadcrumbItem>
        <BreadcrumbItem>业主</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <section>
      <Form inline>
        <FormItem label="注册日期" :label-width="85">
          <DatePicker style="width: 230px" v-model="dateRange" type="daterange" :clearable="true"></DatePicker>
        </FormItem>
        <FormItem label="业主" :label-width="60">
          <Input v-model="search.query" placeholder="姓名／手机号"></Input>
        </FormItem>
        <FormItem label="账户性质" :label-width="85">
          <Select style="width: 120px" v-model="search.type">
            <Option :value="-1">全部</Option>
            <Option :value="1">个人</Option>
            <Option :value="2">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="身份认证状态" :label-width="110">
          <Select style="width: 120px" v-model="search.isAccept">
            <Option :value="-1">全部</Option>
            <Option :value="1">已验证</Option>
            <Option :value="0">未验证</Option>
          </Select>
        </FormItem>
        <FormItem label="跟单进度" :label-width="100">
          <Select style="width: 120px" v-model="search.followUpLevel">
            <Option :value="-1">全部</Option>
            <Option :value="0">无</Option>
            <Option :value="1">未跟进</Option>
            <Option :value="2">跟进中</Option>
            <Option :value="3">完成</Option>
          </Select>
        </FormItem>
        <FormItem label="是否创客" :label-width="85">
          <Select style="width: 120px" v-model="search.isMaker">
            <Option :value="-1">全部</Option>
            <Option :value="1">是</Option>
            <Option :value="0">否</Option>
          </Select>
        </FormItem>
        <FormItem label="所属开发" :label-width="85">
          <Input v-model="search.fromDeveloper" placeholder="姓名/手机号"></Input>
        </FormItem>
        <FormItem label="所属俱乐部" :label-width="95">
          <Input v-model="search.club" placeholder="名称/编号"></Input>
        </FormItem>
        <br>
        <FormItem>
          <Button type="primary" @click="queryByPrama">查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="addHoster">新增业主</Button>
        </FormItem>
      </Form>
      <Tabs @on-click="tabChange" style="width:1500px">
        <TabPane label="预业主" name="pre" class="tab-pane">
          <Table :columns="column" :data="hosterList" :loading="tableLoad"></Table>
        </TabPane>
        <TabPane label="认证业主" name="authenticated" class="tab-pane">
          <Table :columns="column" :data="hosterList" :loading="tableLoad"></Table>
        </TabPane>
        <TabPane label="解约业主" name="out" class="tab-pane">
          <Table :columns="column" :data="hosterList" :loading="tableLoad"></Table>
        </TabPane>
      </Tabs>
      <Page show-total show-sizer :total="total" :page-size="search.size" :current="search.page" @on-change="pageChange" @on-page-size-change="pageSizeChange"></Page>
    </section>
    <Modal v-model="modal" ref="hosterModel" title="新增业主" :loading="true" @on-ok="submitHoster">
      <Form label-position="left" ref="hoserForm" :label-width="120" :model="hoster" :rules="rules">
        <FormItem label="姓名／公司名" prop="name">
          <Input type="text" :maxlength="255" v-model="hoster.name"></Input>
        </FormItem>
        <FormItem label="性别" prop="gender">
          <Select type="text" v-model="hoster.gender">
            <Option :value="0">男</Option>
            <Option :value="1">女</Option>
          </Select>
        </FormItem>
        <FormItem label="手机号码" prop="mobile">
          <Input type="text" v-model="hoster.mobile"></Input>
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input type="text" :maxlength="255" v-model="hoster.email"></Input>
        </FormItem>
        <FormItem label="省份" prop="province">
          <Select v-model="hoster.province" @on-change="changeProvice">
            <Option v-for="(item, index) in provinceList" v-if="item" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="市" prop="city">
          <Select v-model="hoster.city" @on-change="changeCitys">
            <Option v-for="(item, index) in cityList" v-if="item" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="地区" prop="district">
          <Select v-model="hoster.district">
            <Option v-for="(item, index) in areaList" v-if="item" :key="index" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="详细地址" prop="address">
          <Input type="text" :maxlength="500" v-model="hoster.address"></Input>
        </FormItem>
        <FormItem label="账户性质" prop="type">
          <Select type="text" v-model="hoster.type" :on-change="changeAuthType">
            <Option :value="1">个人</Option>
            <Option :value="2">企业</Option>
          </Select>
        </FormItem>
        <FormItem label="是否创客" prop="isMaker">
          <Select type="text" v-model="hoster.isMaker">
            <Option :value="1">是</Option>
            <Option :value="0">否</Option>
          </Select>
        </FormItem>
        <FormItem v-if="hoster.isMaker" label="有无俱乐部">
          <RadioGroup v-model="hoster.isJoinedClub" @on-change="changeRadio">
            <Radio :label="1">有</Radio>
            <Radio :label="0">无</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="hoster.isMaker && !hoster.isJoinedClub" label="所属开发人员" prop="developerId">
          <Select type="text" v-model="hoster.developerId" filterable ref="selectDev" clearable>
            <Option v-for="develop in developList" :key="develop.id" :value="develop.id">{{`${develop.name}-${develop.mobile}`}}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="hoster.isMaker && hoster.isJoinedClub" label="所属俱乐部" prop="clubId">
          <Select type="text" v-model="hoster.clubId" filterable ref="selectClub" clearable>
            <Option v-for="club in clubList" :key="club.id" :value="club.id">{{`${club.clubName}-${club.clubNo}-${club.memberNum}`}}</Option>
          </Select>
        </FormItem>
        <FormItem label="开户银行名称">
          <Input type="text" :maxlength="32" v-model="hoster.bankName"></Input>
        </FormItem>
        <FormItem label="开户名">
          <Input type="text" :maxlength="32" v-model="hoster.bankUser"></Input>
        </FormItem>
        <FormItem label="银行账号" prop="bankAccount">
          <Input type="text" :maxlength="22" v-model="hoster.bankAccount"></Input>
        </FormItem>
        <FormItem label="信用代码" v-if="hoster.type === 2">
          <Input type="text" v-model="hoster.creditNo"></Input>
        </FormItem>
        <FormItem label="上传营业执照" v-if="hoster.type === 2">
          <Upload 
          name= "file"
          :data= "uploadData"
          action= "https://upload.qiniup.com/"
          :before-upload= "beforeUpload"
          :on-success= "upImageSuccess"
          :on-error= "upImageError"
          :on-remove= "removeUpImage"
          >
            <Button type="primary" icon="ios-cloud-upload-outline">Upload files</Button>
          </Upload>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import moment from 'moment';
import {phoneRegular, emailRegular, numRegExp} from "../../utils/regular";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.tabName = 'pre'
    // let list = (await API.omsAPI[this.env].php.hosterList()).data.retdata;
    // Object.assign(this, list);
  },
  mounted(){
    this.$Notice.config({
      top: 100
    });
    this.queryList()
    this.queryClubList()
    this.queryDevelop()
    this.getProvince()
  },
  data(){
    const validateTrim = (rule, value, callback) =>{
      console.info(value)
      if( value.trim().length === 0 ) {
        callback(new Error('不能为空格'))
      }else{
        callback()
      }
    }
    return{
      uploadData: {},
      tableLoad: true,
      hosterList: [],
      total:0,
      modal:false,
      dateRange: [moment().subtract(15, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      search: {
        club: '',
        fromDeveloper: '',
        followUpLevel: -1,
        isAccept: -1,
        isMaker: -1,
        query: '',
        queryType: 'pre',
        type: -1,
        page: 1,
        size: 10,
        startDate: '',
        endDate: ''
      },
      column:[
        {
          title: "业主ID",
          width: 150,
          key: "id",
          align: "center",
        },
        {
          title: "姓名",
          width: 150,
          key: "name",
          align: "center",
        },
        {
          title: "性别",
          width: 150,
          key: "gender",
          align: "center",
          render: (h, param) => {
            return h('span', param.row.gender ? '女' : '男')
          }
        },
        {
          title: "手机号码",
          width: 150,
          key: "mobile",
          align: "center",
        },
        {
          title: "邮箱",
          width: 150,
          key: "email",
          align: "center",
        },
        {
          title: `待签协议数`,
          width: 150,
          key: "contractCount",
          align: "center",
        },
        {
          title: "房间数量",
          width: 150,
          key: "roomCount",
          align: "center",
        },
        {
          title: "账户性质",
          width: 150,
          key: "type",
          align: "center",
          render: (h, param) => {
            return h('span', ['', '个人', '企业'][param.row.type])
          }
        },
        {
          title: "身份验证状态",
          width: 150,
          key: "isAccept",
          align: "center",
          render: (h, param) => {
            return h('span', param.row.isAccept ? '已验证' : '未验证')
          }
        },
        {
          title: "所属开发员",
          width: 150,
          align: "center",
          render: (h, param) => {
            return h('span', `${param.row.devName || ''}-${param.row.devMobile || ''}`)
          }
        },
        {
          title: "所属俱乐部",
          width: 150,
          align: "center",
          render: (h, param) => {
            return h('span', `${param.row.clubName || ''}-${param.row.clubNo || ''}`)
          }
        },
        {
          title: "跟单进度",
          width: 150,
          align: "center",
          render: (h, p) => {
            return h('span', ['无','未跟进','跟进中','完成'][p.row.followUpLevel])
          }
        },
        {
          title: "跟单员",
          width: 150,
          key: 'merchandiser',
          align: "center",
        },
        {
          title: "注册时间",
          width: 200,
          key: "createdAt",
          align: "center",
          render:(h, param) => h('span', moment(param.row.createdAt).format('YYYY-MM-DD HH:mm:ss'))
        },
        {
          title: "操作",
          width: 200,
          align: "center",
          render:(h, param) => h('div', [
            h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  window.open(`#/BlueHoster/BlueHoster/hosterDetail?hosterId=${param.row.id}`)
                }
              }
            }, '查看详情'),
          ])
        }
      ],
      rules: {
        name: [
          { required: true, validator: validateTrim, message: '该项不能为空', trigger: 'blur' },
        ],
        gender: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '该项不能为空', trigger: 'blur' },
          {pattern: phoneRegular, message: '格式不正确', trigger: 'change'}
        ],
        email: [
          {pattern: emailRegular, message: '格式不正确', trigger: 'change'}
        ],
        province: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        city: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        district: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, validator: validateTrim, message: '该项不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        isMaker: [
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        bankAccount: [
          {pattern: numRegExp, message: '格式不正确', trigger: 'change'}
        ],
        developerId:[
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
        clubId:[
          { required: true, type: 'number', message: '该项不能为空', trigger: 'blur' }
        ],
      },
      hoster:{},
      clubList: [],
      developList: [],
      provinceList: [],
      cityList: [],
      areaList: []
    }
  },
  watch: {
    dateRange: {
      handler: function(newVal){
        if(newVal[0]) {
          this.search.startDate = moment(newVal[0]).format('YYYY-MM-DD')
          this.search.endDate = moment(newVal[1]).format('YYYY-MM-DD')
        }else {
          this.search.startDate = ''
          this.search.endDate = ''
        }
      },
      deep: true
    }
  },
  methods:{
    tabChange(name) {
      const titles = {
        pre: '待签协议数',
        authenticated: '已签协议数',
        out: '解约协议数'
      }
      this.column[5].title = titles[name]
      this.search.page = 1;
      this.search.size = 10;
      this.search.queryType = name
      this.queryList()
    },
    queryByPrama() {
      this.search.page = 1
      this.search.size = 10
      this.queryList()
    },
    pageChange(page) {
      this.search.page = page
      this.queryList()
    },
    pageSizeChange(size) {
      this.search.page = 1;
      this.search.size = size
      this.queryList()
    },
    changeRadio() {
      this.hoster.developerId = ''
      this.hoster.clubId = ''
      if (this.hoster.isJoinedClub == 1) {
        this.$refs.selectDev.clearSingleSelect()
      } else if (this.hoster.isJoinedClub == 0) {
        this.$refs.selectClub.clearSingleSelect()
      }
    },
    async queryList() {
      this.tableLoad = true
      let param = this.resetObj(this.search)
      param.startDate = this.dateRange[0] ? moment(this.dateRange[0]).format('YYYY-MM-DD') : ''
      param.endDate = this.dateRange[1] ? moment(this.dateRange[1]).format('YYYY-MM-DD') : ''
      let resp = (await API.omsAPI[this.env].php.hosterList(param)).data;
      if(resp.retcode===0) {
        this.hosterList = resp.retdata.content
        this.total = resp.retdata.totalElements
      }else{
        this.hosterList = []
        this.total = 0
      }
      this.tableLoad = false
    },
    async queryClubList() {
      this.clubList = (await API.omsAPI[this.env].bluehost.queryClubList({}, this.token)).data.content || [];
    },
    async queryDevelop() {
      let resp = (await API.omsAPI[this.env].php.developList()).data
      if(resp.retcode === 0) {
        this.developList = resp.retdata.content || []
      }
    },
    changeProvice(proviceId) {
      this.cityList = []
      this.getCity(proviceId)
    },
    changeCitys(cityId){
      this.areaList = []
      this.getArea(cityId)
    },
    async getProvince() {
      let resp = (await API.omsAPI[this.env].php.provincesList()).data;
      this.provinceList = resp
    },
    async getCity(proviceId) {
      let resp =  (await API.omsAPI[this.env].php.cityList({"id": proviceId})).data;
      this.cityList = resp
      this.hoster.city = this.cityList[0].id
    },
    async getArea(cityId) {
      let resp =  (await API.omsAPI[this.env].php.countyslist({"id": cityId})).data;
      this.areaList = resp
      this.hoster.district = this.areaList[0].id
    },
    addHoster() {
      this.hoster = {
        gender: 0,
        name: '',
        mobile: '',
        email: '',
        province: 1,
        city: 52791,
        district: 72,
        address: '',
        type: 1,
        isAccept: 0,
        creditNo: '',
        isMaker: 0,
        isJoinedClub: 1,
        developerId: '',
        clubId: '',
        bankAccount: '',
        bankName: '',
        bankUser: '',
      }
      this.changeProvice(this.hoster.province)
      this.changeCitys(this.hoster.city)
      this.modal = true
    },
    submitHoster() {
      this.$refs['hoserForm'].validate(valid => {
        console.info('1111111111111',valid)
        if(valid) {
          this.subHosterEvent()
        }else {
          this.$refs['hosterModel'].buttonLoading = false
        }
      })
    },
    async subHosterEvent() {
      if((this.hoster.type - 0) === 2 && !this.hoster.businessLicenseUrl){
        this.$Notice.error({
          title: '请上传营业执照',
          desc: ''
        })
        this.$refs['hosterModel'].buttonLoading = false
        return ''
      }
      let jsonObj = JSON.parse(JSON.stringify(this.hoster))
      jsonObj.province = this.getNameById(this.hoster.province, this.provinceList)[0].name
      jsonObj.city = this.getNameById(this.hoster.city, this.cityList)[0].name
      jsonObj.district = this.getNameById(this.hoster.district, this.areaList)[0].name
      let resp = (await API.omsAPI[this.env].php.addHoster(jsonObj)).data
      this.$refs['hosterModel'].buttonLoading = false
      if(resp.retcode == 1){
        this.modal = false
      }else {
        this.$Notice.error({
          title: '操作失败',
          desc: resp.retmsg
        })
      }
    },
    getNameById(id, list){
      return list.filter(item => {
        return item.id === id
      })
    },
    resetObj(obj){
      let newObj = {}
      for (let key in obj) {
        newObj[key] = obj[key]
        obj[key] === -1 && (newObj[key] = '')
      }
      return newObj
    },
    // 新增业主，变更身份类型的时候
    changeAuthType(value){
      if(value){
        this.hoster.businessLicenseUrl = ''
      }else{
        delete this.hoster.businessLicenseUrl
      }
    },
    // 图片上传操作
    async beforeUpload(file) {
      console.info(`${file}`);

      let token = (await API.omsAPI[this.env].common.getUploadToken(true, this.token)).data;
      if(!token || token.retcode){
        this.$Notice.error({
          title: '获取token失败',
          desc: '请重新上传'
        })
        return false;
      }else{
        this.uploadData.token = token;
        // this.uploadData.name = `${(Date.now() / 1000) | 0}_${file.name}`;
        // this.uploadData["x:fileDirId"] = 636;
        this.uploadData["x:isPrivate"] = 1;
        this.uploadData["x:remark"] = "新增营业执照";
        return true;
      }
    },
    upImageSuccess(resp, file, fileList){
      console.info('----------------------');
      console.info(resp, file, fileList);
      this.hoster.businessLicenseUrl = resp.materialBase.url;

    },
    upImageError(error, file, fileList){
      console.info('----------------------');
      console.info(error, file, fileList);
      this.$Notice.error({
        title: '上传失败',
        desc: '请重新上传'
      })
    },
    removeUpImage(file, fileList){
      console.info('----------------------');
      console.info(file, fileList);
      this.hoster.businessLicenseUrl = ''
    },
  }
}
</script>

<style lang="scss" scoped>
// .tab-pane{
//   min-height: 800px
// }
</style>



// WEBPACK FOOTER //
// src/pages/blue-hoster/hoster-list.vue